module.exports = __webpack_public_path__ + "img/r-196.bdd237aa.jpg";